module.exports = __webpack_public_path__ + "media/mypage/images/special/005-c24b6e0a3a6c61a5291717cdf06a432f.jpg";